function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM17.3321 9.70711C17.7226 9.31658 17.7226 8.68342 17.3321 8.29289C16.9416 7.90237 16.3084 7.90237 15.9179 8.29289L10.1314 14.0794L7.71345 11.6175C7.32646 11.2234 6.69332 11.2177 6.29929 11.6047C5.90527 11.9917 5.89956 12.6249 6.28655 13.0189L9.41155 16.2007C9.59848 16.391 9.85372 16.4988 10.1205 16.5C10.3873 16.5012 10.6435 16.3957 10.8321 16.2071L17.3321 9.70711Z"
});

function SvgCheckFilled(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-check-filled",
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check-filled.0172f9e1.svg";
export { ForwardRef as ReactComponent };